import { Gift, ArrowRight } from "lucide-react";
import { Heart, Star, Rainbow, Sun, Squiggle, Smiley } from "./Illustrations";

export default function FreeAssessment() {
  const scrollToContact = () => {
    const el = document.getElementById("epikoinonia");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const benefits = [
    { text: "Πλήρης συνεδρία γνωριμίας με την υπεύθυνη", color: "#FBC4D0" },
    { text: "Εντοπισμός αναγκών του παιδιού", color: "#FBE4A8" },
    { text: "Ενημέρωση γονέων για τα επόμενα βήματα", color: "#B8D6BE" },
    { text: "Χωρίς καμία οικονομική επιβάρυνση", color: "#B8D6E8" },
  ];

  return (
    <section
      id="free-assessment"
      data-testid="free-assessment-section"
      className="py-24 md:py-28 bg-brand-bg relative overflow-hidden"
    >
      <Sun className="absolute top-10 left-10 hidden md:block animate-spin-slow opacity-90" size={70} />
      <Star className="absolute top-32 right-20 animate-pulse-soft" size={28} color="#FBE4A8" />
      <Heart className="absolute bottom-32 left-1/4 animate-pulse-soft hidden md:block" size={32} color="#FBC4D0" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-white rounded-[3rem] overflow-hidden border-4 border-dashed border-brand-pink p-8 sm:p-12 md:p-16 shadow-[0_15px_0_-3px_#FBE4A8]">
          <Rainbow className="absolute -top-8 -right-12 hidden lg:block" size={280} />
          <Heart className="absolute top-6 left-6 animate-wiggle" size={32} color="#FBC4D0" />
          <Star className="absolute bottom-8 right-1/3 animate-pulse-soft" size={24} color="#FBE4A8" />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-brand-yellow border-2 border-brand-text/15 mb-6 -rotate-2">
                <Gift size={18} className="text-brand-primaryHover" />
                <span className="font-body text-sm font-bold text-brand-text">
                  Δωρεάν Υπηρεσία
                </span>
              </div>
              <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight text-brand-text">
                Δωρεάν{" "}
                <span className="relative inline-block">
                  <span className="relative z-10 font-hand text-5xl sm:text-6xl lg:text-7xl text-brand-primary">
                    Αξιολόγηση
                  </span>
                </span>
                <br />για κάθε παιδί
                <Heart size={36} className="inline-block ml-2 animate-pulse-soft align-middle" color="#F4A899" />
              </h2>
              <Squiggle className="my-5" width={160} color="#B8D6BE" />
              <p className="font-body text-base sm:text-lg text-brand-textSoft leading-relaxed max-w-xl">
                Πιστεύουμε ότι το πρώτο βήμα δεν πρέπει να αποτελεί εμπόδιο.
                Γι' αυτό, στους Ορίζοντες Ανάπτυξης η αρχική αξιολόγηση κάθε
                παιδιού είναι εντελώς δωρεάν.
              </p>

              <button
                onClick={scrollToContact}
                data-testid="free-assessment-cta"
                className="mt-8 inline-flex items-center gap-2 px-7 py-4 rounded-full bg-brand-primary text-white font-bold hover:bg-brand-primaryHover transition-all shadow-[0_5px_0_#5B4F46] hover:translate-y-[3px] hover:shadow-[0_2px_0_#5B4F46]"
              >
                Κλείστε Ραντεβού
                <ArrowRight size={18} />
              </button>
            </div>

            <div className="lg:col-span-5">
              <ul className="space-y-3">
                {benefits.map((b, idx) => (
                  <li
                    key={idx}
                    data-testid={`benefit-${idx}`}
                    className={`flex items-start gap-3 p-4 rounded-2xl border-2 border-dashed border-brand-text/15 ${idx % 2 === 0 ? '-rotate-1' : 'rotate-1'} hover:rotate-0 transition-transform`}
                    style={{ backgroundColor: b.color + "55" }}
                  >
                    <Heart size={22} className="flex-shrink-0 mt-0.5" color={b.color} />
                    <span className="font-body text-brand-text text-sm sm:text-base font-medium">{b.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
